import { useState } from 'react';
import { Avatar } from '@mui/material';
import { authService } from '../services/authService';

/**
 * Avatar que busca foto do profissional no bucket CloudFlare R2
 * Sempre tenta carregar a foto. Se não existir (404), exibe as iniciais
 */
export default function ProfessionalAvatar({ professionalId, photoTimestamp, name, sx, children }) {
  const [imageError, setImageError] = useState(false);

  // Obter userId do JWT para construir path seguro
  const userInfo = authService.getUserInfo();
  const userId = userInfo?.userId;

  // URL da foto no bucket CloudFlare R2
  // Formato: userId/professionalId.jpg (namespace por conta para segurança)
  // Cache busting: adiciona ?v=timestamp apenas se photoTimestamp existir (após upload)
  const photoUrl = userId && professionalId 
    ? `https://photos.agendario.com.br/${userId}/${professionalId}.jpg${photoTimestamp ? `?v=${photoTimestamp}` : ''}` 
    : null;

  const handleImageError = () => {
    console.log('Erro ao carregar imagem:', photoUrl);
    setImageError(true);
  };

  // Avatar só carrega src se NÃO houver children
  // Sempre tenta carregar se photoUrl existir, só mostra children após erro
  const shouldShowImage = photoUrl && !imageError;
  
  console.log('ProfessionalAvatar render:', { professionalId, photoUrl, imageError, shouldShowImage });

  return (
    <Avatar
      src={shouldShowImage ? photoUrl : undefined}
      imgProps={{
        onError: handleImageError
      }}
      sx={sx}
    >
      {shouldShowImage ? null : children}
    </Avatar>
  );
}
